import { signal } from "@lit-labs/preact-signals";
export const launch = signal(null);
export const scenario = signal(null);
export const draft = signal(null);
export function resetForTests() {
    launch.value = null;
    scenario.value = null;
    draft.value = null;
}
